import DialogRechercheInstance from './DialogRechercheInstance';
import DialogAssociationInstance from './DialogAssociationInstance';
import DialogRechercheParticipantGestionnaire from './DialogRechercheParticipantGestionnaire';

export default {
  install(Vue) {
    Vue.component('dialogRechercheInstance', DialogRechercheInstance);
    Vue.component('dialogAssociationInstance', DialogAssociationInstance);
    Vue.component(
      'dialogRechercheParticipantGestionnaire',
      DialogRechercheParticipantGestionnaire,
    );
  },
};
